import css from 'styled-jsx/css';
import { zIndex } from '../../../config/styles';

const styles = css`
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: ${zIndex.MobileFullscreenModal.modal};
    padding-top: 20px;
  }

  .modal-content {
    background: white;
    padding: 10px;
    border-radius: 5px;
    position: relative;
    width: 480px;
    height: 600px;
    overflow: auto;
  }

  .modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    font-size: 30px;
    cursor: pointer;
    line-height: 30px;
  }
`;

export default styles;
